export default function TableWrapper({ children }) {
  return <section style={{ overflow: 'hidden' }}>{children}</section>;
}
